import { SupportedChainId } from './chains'

export const SAFE_SERVICE_URLS: Partial<Record<SupportedChainId, string>> = {
  [SupportedChainId.BERA]: 'https://safe-transaction-berachain.safe.global',
  [SupportedChainId.BEPOLIA]: 'https://safe-transaction-berachain-bepolia.safe.global',
}

export const SAFE_POLLING_CONFIG = {
  INTERVAL_MS: 4_000,
  MAX_ATTEMPTS: 60, // 4 mins total
  RATE_LIMIT_DELAY_MS: 5_000,
} as const

export type SafeTransactionStatus = 'AWAITING_CONFIRMATIONS' | 'AWAITING_EXECUTION' | 'CANCELLED' | 'FAILED' | 'SUCCESS'

export type SafeTransactionResponse = {
  txHash?: string | null
  txStatus?: SafeTransactionStatus
  transactionHash?: string | null
  isExecuted?: boolean
  isSuccessful?: boolean | null
}
